/* ========== SURFACE CHART (area-fill approximation) ========== */

import { COLORS, drawAxes, drawGridlines, drawLegend, getMinMaxRange } from './utils';

export function drawSurfaceChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var mmr = getMinMaxRange(seriesArr, chartObj, height);
  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range, mmr.numGridLines, mmr.label);

  seriesArr.forEach(function (series, sIdx) {
    var data = series.data;
    if (!data || data.length === 0) return;
    var pointSpacing = width / Math.max(1, data.length - 1);
    var color = COLORS[sIdx % COLORS.length];

    ctx.globalAlpha = 0.3;
    ctx.fillStyle = color;
    ctx.beginPath();
    data.forEach(function (value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.lineTo(x + (data.length - 1) * pointSpacing, y + height);
    ctx.lineTo(x, y + height);
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = 1;

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    data.forEach(function (value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.stroke();
  });

  var cats = chartObj.categories || [];
  var numCats = Math.max.apply(null, seriesArr.map(function (s) { return s.data.length; }));
  var catSpacing = width / Math.max(1, numCats - 1);
  for (var ci = 0; ci < numCats; ci++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[ci] || ('' + (ci + 1)), x + ci * catSpacing, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr, { lineStyle: true });
}
